import { styled } from "@mui/material";
import Grid from "components/primitives/Grid";

export const OverflowGrid = styled(Grid)(() => ({
  overflowY: "auto",
}));
